module.exports = __webpack_public_path__ + "img/estsuelcon-white.61c9e867.png";